"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallImagesWrapper = exports.Root = exports.Inner = exports.ContentWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(12)
  },
  [theme.breakpoints.between('sm', 'md')]: {
    flexDirection: 'row',
    gap: theme.spacing(6)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(3),
    maxWidth: _constants.LARGE_IMAGE_DESKTOP_WIDTH,
    minWidth: `min(50%, ${_constants.LARGE_IMAGE_DESKTOP_WIDTH / 2}px)`
  }
}));
const SmallImagesWrapper = exports.SmallImagesWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(2)
  }
}));
const ContentWrapper = exports.ContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: 0,
  fontSize: '1.4rem',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '50%'
  }
}));
